import { render, staticRenderFns } from "./TheHome.vue?vue&type=template&id=12b59df0&lang=pug"
import script from "./TheHome.vue?vue&type=script&lang=js"
export * from "./TheHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports